import Vue from "vue";

const errModal = {
    props: {
        i18n: Object,
    },
    showDialogError(obj) {
        let isObj = typeof obj === "object";

        if (isObj && obj.non_field_errors) {
            Vue.prototype.$modal.show("dialog", {
                title: this.$t("threads.mistake"),
                text: generateErrList(obj.non_field_errors),
                buttons: [
                    {
                        title: this.$t("mixins.ok"),
                    },
                ],
            });

            function generateErrList(obj) {
                let list = "<ul>";
                for (let key in obj) {
                    list = list.concat("<li>", obj[key], "</li>");
                }
                list = list.concat("</ul>");
                return list;
            }
        } else if (!isObj) {
            Vue.prototype.$modal.show("dialog", {
                title: this.$t("threads.mistake"),
                text: this.$t("threads.serverProblem"),
                buttons: [
                    {
                        title: this.$t("mixins.ok"),
                    },
                ],
            });
        }
    },
};

export default errModal;
